var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02823 2.09399L1.01686 10.5199C1.00159 10.5512 0.996756 10.5866 1.00305 10.6209C1.00935 10.6552 1.02645 10.6866 1.05186 10.7104L11.8856 21.0918C11.9164 21.1213 11.9574 21.1378 12 21.1378C12.0426 21.1378 12.0836 21.1213 12.1144 21.0918L22.9482 10.7111C22.9736 10.6872 22.9907 10.6558 22.997 10.6216C23.0033 10.5873 22.9984 10.5519 22.9832 10.5205L18.9718 2.09464C18.9588 2.06634 18.938 2.04237 18.9118 2.02559C18.8856 2.00881 18.8551 1.99993 18.824 2.00001H5.1773C5.14604 1.99962 5.11532 2.00829 5.08887 2.02497C5.06242 2.04164 5.04136 2.06561 5.02823 2.09399Z",
    fill: "#34C38F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3919 11.3851C13.3141 11.391 12.9123 11.415 12.0159 11.415C11.3029 11.415 10.7967 11.3936 10.6191 11.3851C7.86386 11.2639 5.80729 10.7843 5.80729 10.2101C5.80729 9.6358 7.86386 9.15682 10.6191 9.03367V10.9075C10.7993 10.9204 11.3152 10.9509 12.0282 10.9509C12.8837 10.9509 13.3122 10.9152 13.3893 10.9081V9.03497C16.1387 9.15746 18.1908 9.63709 18.1908 10.2101C18.1908 10.783 16.1394 11.2626 13.3893 11.3845L13.3919 11.3851ZM13.3919 8.84117V7.16442H17.2289V4.60748H6.7821V7.16442H10.6185V8.84052C7.50025 8.98376 5.15526 9.60144 5.15526 10.3416C5.15526 11.0818 7.50025 11.6988 10.6185 11.8427V17.2159H13.3912V11.8408C16.5023 11.6975 18.8434 11.0805 18.8434 10.341C18.8434 9.60144 16.5043 8.98441 13.3912 8.84052L13.3919 8.84117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.acc1c765e8dd38175cc53d0372212639.svg";
export { ForwardRef as ReactComponent };